import React from 'react';
import { ComponentConfig } from '../../interface/interface';
import { componentTypes, Schema } from '@data-driven-forms/react-form-renderer';
import { GridProps } from '@mui/system';

export interface AttributeSchemaData {
  attributeName: string,
  editData?: any,
}

export const AttributeSchema = (props: AttributeSchemaData) => {
  const {
    attributeName,
    editData,
  } = props;
  return {
    fields: [
      {
        component: componentTypes.TEXT_FIELD,
        label: 'Attribute',
        placeholder: 'Attribute Name',
        name: 'attributeName',
        required: true,
        disabled: false,
        initialValue: editData?.name,
        validate: [{
          type: 'required',
          message: 'Attribute name is required'
        }]
      }
    ]
  } as Schema extends GridProps ? GridProps : never;
};
